import { render, staticRenderFns } from "./form-queries-query-comment.vue?vue&type=template&id=55c27c4a&scoped=true&"
import script from "./form-queries-query-comment.vue?vue&type=script&lang=js&"
export * from "./form-queries-query-comment.vue?vue&type=script&lang=js&"
import style0 from "./form-queries-query-comment.vue?vue&type=style&index=0&id=55c27c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c27c4a",
  null
  
)

component.options.__file = "form-queries-query-comment.vue"
export default component.exports